import {
  DeleteInventoryImageRequest,
  InventoryActions,
} from "../domain/inventory";
import { deleteInventoryImageService } from "../infrastructure/services/deleteInventoryImageService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const deleteInventoryImage = {
  async execute(reference: string, position: number): Promise<void> {
    const request: DeleteInventoryImageRequest =
      await InventoryActions().inventoryDeleteImageRequest(reference, position);
    await deleteInventoryImageService.execute(
      await tokenValidation.execute(),
      request
    );
  },
};
